// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f3a7cec7","667":"df57572e"}[chunkId] + ".chunk.js";
};